export default "__VITE_ASSET__0bf4048e__"